import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import compose from 'lodash.flowright';
import { withRouter } from 'react-router-dom';
import { useQuery } from 'react-apollo';

import FullScreenLoader from '../../../../../../components/global/FullScreenLoader';
import {
  ALBUM_SLIDESHOW_MODE,
  ALBUM_SLIDESHOW_STATUS,
} from '../../../../../../constants/albums';
import AlbumSlideshow from '../../AlbumSlideshow';
import VideoSlideshow from '../../VideoSlideshow';
import { AlbumSlideshowForModeCheck } from '../../../../../../graphql/queries/albums';
import { useContributorPermission } from '../../../../services/contributors';
import AlbumSlideshowMeta from './components/AlbumSlideshowMeta';

const propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      albumId: PropTypes.string,
    }),
  }),
};

const SlideshowView = ({ match }) => {
  const { albumId } = match.params;
  const { data: { album } = {}, loading } = useQuery(
    AlbumSlideshowForModeCheck,
    {
      variables: {
        id: albumId,
      },
      skip: !albumId,
    },
  );

  const { isContributor, isOwner } = useContributorPermission({
    entityId: albumId,
  });

  // Scenario A: Album is not loaded or not found
  if (loading || !album || !album?.slideshow) {
    return (
      <Fragment>
        <AlbumSlideshowMeta album={album} />
        <FullScreenLoader />
      </Fragment>
    );
  }

  // Scenario B: User is trying to access a public slideshow that's not been published
  if (
    isOwner &&
    !isContributor &&
    album?.slideshow?.mode === ALBUM_SLIDESHOW_STATUS.DRAFT
  ) {
    return (
      <Fragment>
        <AlbumSlideshowMeta album={album} />
        <FullScreenLoader />
      </Fragment>
    );
  }

  if (album.slideshow?.mode === ALBUM_SLIDESHOW_MODE.ALL_VIDEOS) {
    return (
      <Fragment>
        <AlbumSlideshowMeta album={album} />
        <VideoSlideshow />
      </Fragment>
    );
  }

  return (
    <Fragment>
      <AlbumSlideshowMeta album={album} />
      <AlbumSlideshow />
    </Fragment>
  );
};

SlideshowView.propTypes = propTypes;

export default compose(withRouter)(SlideshowView);
